import { Profile } from '@/components/registration/module/types'
import { InterviewOffersQuery } from '@/graphql-schema'
import { EditIntent, IsErrorSink, NotNull, Unpacked } from '@/utils'

export { Action } from './actions'
export { Mutation } from './mutations'

export type RootState = any

export type Offer = Unpacked<NotNull<InterviewOffersQuery['offers']>['nodes']>

export interface ModuleState extends IsErrorSink {
  now: Date
  editOffer: EditIntent<'reschedule', Offer> | null
  offers: Offer[]
  subscription: ZenObservable.Subscription | null
}
